/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import store from '@/app/store/store';
import { placeCaretAtEnd } from '@/app/utils/helpers';
import SidebarPopUp from '../../components/popup';
import DropdownGroupControl from '../../controlsv2/dropdown-group';
import { svg } from '../../utils/actions.assets';
import { getAtomType } from '../../utils/getAtomType';
import { getActionDataEditorDefault, listActions } from '../actions.actions';
// import { getActionDataEditorDefault } from "../actions.actions";
// import { listActionsHtml, targetItemHtml } from "../actions.html";
import { listActionsHtml, targetItemHtml } from '../actions.html';
import { mergeActionToEditor } from '../actions.utils';
import type { ActionData, ActionDataEditor, TargetData, TargetDataEditor } from '../type';
import ActionItem from './ActionItem';

/**
 * Flow Action Item
 */
export default class TargetItem implements TargetDataEditor {
  id: string;
  actions: ActionDataEditor[] = [];
  actionType: string;
  atomLabel: string;
  atomType: string;
  rename: string;

  actionItems = {};

  $selectTargets: JQuery;
  $after: JQuery | undefined;
  $gfFrame = jQuery('#gfFrame');
  $gryffEditor = this.$gfFrame.contents().find('.gryffeditor').first();
  $bodyEditor = this.$gfFrame.contents().find('body').first();
  $gfContainer = jQuery('#gfContainer');
  windowFrame = (this.$gfFrame.get(0) as any).contentWindow || false;

  selectorClass = '.gf_row[data-label="Row"], .element-wrap, .module-wrap, .gf-popupAnchor';

  $html: JQuery;
  $targetLabel: JQuery;
  $targetLabelText: JQuery;
  $newTarget: JQuery;
  dropdownActions: DropdownGroupControl;
  $listActions: JQuery;
  $targetActions: JQuery;

  flagRemoved = false;
  // flagIsQueue = false;
  flagIsRename = false;
  flagClickOpenRename = false;
  flagEnableSelectTarget = false;

  duplicateCallback: any;

  cacheEvents: any = {};

  /**
   * constructor
   * @param $selectTargets ..
   * @param targetData .
   * @param $after .
   */
  constructor($selectTargets: JQuery, targetData: TargetDataEditor, $after?: JQuery) {
    this.id = targetData.id;
    this.actions = targetData.actions;
    this.atomLabel = targetData.atomLabel;
    this.atomType = targetData.atomType;
    this.rename = targetData.rename || '';
    this.$selectTargets = $selectTargets;
    this.$after = $after;

    this.render();
  }

  /**
   * render
   */
  render(): void {
    const _this = this;
    const $html = jQuery(
      targetItemHtml({
        id: this.id,
        actions: this.actions,
        atomLabel: this.atomLabel,
        atomType: this.atomType,
        rename: this.rename,
      }),
    );
    this.$html = $html;
    if (this.$after) {
      this.$after.after(this.$html);
    } else {
      this.$selectTargets.append(this.$html);
    }

    //add event
    this.$listActions = this.$html.find('.list-actions');
    this.$targetActions = this.$html.find('.target-actions');

    //click enable selectTargetMode
    this.$targetLabel = this.$html.find('.target-label');
    this.$targetLabelText = this.$targetLabel.find('.target-label-text');
    this.$targetLabel
      .find('.change-target')
      .off('click.target-label')
      .on('click.target-label', function (e) {
        e.preventDefault();
        _this.enableSelectTargetMode();
      });

    //more settings event
    const $moreSettings = this.$html.find('.expand-list ul');
    const opts = {
      type: 'simple',
      animationSpeed: 100,
      /**
       * onChange
       * @param data .
       */
      onChange: (data: any) => {
        if (data.value == 'rename') {
          //
          _this.flagClickOpenRename = true;
          _this.enableRename();
          return;
        }
        if (data.value == 'delete') {
          //
          new SidebarPopUp({
            title: 'Deleting This Target?',
            description: `${this.getName()} will be removed from your targets list.`,
            primaryButton: {
              text: 'Delete',
              class: 'gf_btn-danger', // check or add class in style.scss on component
            },
            secondaryButton: {
              text: 'Cancel',
            },
            /**
             * On click delete
             */
            onClickedPrimary() {
              _this.remove();
            },
          });
          return;
        }
        if (data.value == 'duplicate') {
          //
          _this.duplicate();
          return;
        }
      },
    };
    const moreSettingsDropdown = new DropdownGroupControl($moreSettings, opts);

    this.$targetLabel
      .find('.expand')
      .off('click.target-more-settings')
      .on('click.target-more-settings', function (e) {
        e.preventDefault();
        moreSettingsDropdown.toggle();
      });

    // Click outside
    jQuery(window).on('click.outside', function (event) {
      if (_this.flagIsRename && !$(event.target).is(_this.$targetLabelText)) {
        //disable rename
        if (_this.flagClickOpenRename) {
          _this.flagClickOpenRename = false;
          return;
        }
        _this.disableRename();
      }
    });

    for (let i = 0; i < this.actions.length; i++) {
      _this.pushAction(this.actions[i]);
    }

    //button add new action
    this.$newTarget = this.$html.find('.target-add-new');

    //new target event
    this.$newTarget.off('click').on('click', function (e) {
      e.preventDefault();
      if (_this.dropdownActions) {
        _this.dropdownActions.toggle();
      }
    });

    this.applyEventsListActions();

    return;
  }

  /**
   * refresh list actions
   */
  refreshListActions(): void {
    const listHtml = listActionsHtml(this.atomLabel);
    this.$listActions.html(listHtml);
    this.applyEventsListActions();
  }

  /**
   * applyEventsListActions
   */
  applyEventsListActions(): void {
    const _this = this;
    const $selectActions = this.$listActions.find('select');
    const optsAction = {
      /**
       * onChange
       * @param data .
       */
      onChange: async (data: any) => {
        // console.log(data);
        const key = data.value;
        const actionData = getActionDataEditorDefault(key);
        _this.pushAction(actionData);

        //trigger open setting
        const lastKey = Object.keys(_this.actionItems).pop() || '';
        Object(_this.actionItems)[lastKey].$html.find('.action-head').trigger('click');

        store.setValue('update-action', 1);
      },
    };

    //add event
    $selectActions.each(function () {
      _this.dropdownActions = new DropdownGroupControl(jQuery(this), optsAction);
    });
  }

  /**
   * enableRename
   */
  enableRename(): void {
    //
    const _this = this;
    this.flagIsRename = true;
    this.$targetLabelText.removeAttr('disabled');
    placeCaretAtEnd(this.$targetLabelText);
    this.$targetLabelText.on('keydown', function (e) {
      if (e.originalEvent && e.originalEvent?.code == 'Enter') {
        e.preventDefault();
        _this.disableRename();
      }
    });
  }

  /**
   * disableRename
   */
  disableRename(): void {
    //
    const name = this.$targetLabelText.val();
    this.rename = name != undefined ? name.toString() : '';
    this.flagIsRename = false;
    this.$targetLabelText.attr('disabled', 'disabled');
    store.setValue('update-action', 1);
  }

  /**
   * getName
   * @returns string
   */
  getName(): string {
    return this.rename ? this.rename : `${this.atomLabel}: ${this.id}`;
  }

  /**
   * isSelectingTargetMode
   * @returns ..
   */
  isSelectingTargetMode(): boolean {
    if (store.getValue('__selectingTarget') == 1) {
      return true;
    }
    return false;
  }
  /**
   * disableSelectTargetMode
   */
  disableSelectTargetMode(): void {
    const _this = this;
    //add setTimeout to delay
    setTimeout(function () {
      store.setValue('__selectingTarget', 0);

      //add store in iframe
      if (_this.windowFrame && _this.windowFrame.GEMSTORE) {
        _this.windowFrame.GEMSTORE.dispatch('__selectingTarget', 0);
      }

      _this.$gfContainer.removeClass('select-target');
      _this.$bodyEditor.removeClass('select-target');
      _this.$targetLabel.removeClass('selecting');
      _this.$html.removeClass('suggest-select');

      const $mer = _this.$bodyEditor.find(_this.selectorClass);
      $mer.off('mouseover.selecting-target').removeClass('gf-target-box').find('.gf-target-box-label').remove();
      $mer.find('.gf-target-outline').remove();

      _this.$bodyEditor.off('click.select-target').off('mouseover.selecting-target');
      jQuery('#gfLeftSideBar, #divTopBar').off('click.closetarget');

      //back events for body
      const events = (jQuery as any)._data(_this.$bodyEditor[0], 'events');
      for (const keyEvent in Object(_this.cacheEvents)) {
        Object(events)[keyEvent] = Object(_this.cacheEvents)[keyEvent];
      }
      _this.cacheEvents = {};
    }, 16);

    // jQuery(window).off("click.out-target");
  }

  //
  /**
   * suggestSelectTarget
   */
  suggestSelectTarget(): void {
    this.$html.addClass('suggest-select');
  }

  /**
   * enableSelectTargetMode
   */
  enableSelectTargetMode(): void {
    // console.log("enableSelectTargetMode");
    const _this = this;
    this.flagEnableSelectTarget = true;
    store.setValue('__selectingTarget', 1);

    //add store in iframe
    if (this.windowFrame && this.windowFrame.GEMSTORE) {
      this.windowFrame.GEMSTORE.dispatch('__selectingTarget', 1);
    }

    let tempTimeout: any;

    _this.$gfContainer.addClass('select-target');
    const $oldTarget = _this.$bodyEditor.find(_this.id);
    $oldTarget.addClass('gf-target-box');
    _this.$bodyEditor.addClass('select-target');
    _this.$targetLabel.addClass('selecting');

    this.appendInfoBar();

    const $mer = _this.$bodyEditor.find(_this.selectorClass);

    if (tempTimeout) {
      clearTimeout(tempTimeout);
    }
    tempTimeout = setTimeout(function () {
      _this.appendLabelOnTarget($oldTarget);
    }, 16);

    //cache events body to variable
    const events = (jQuery as any)._data(_this.$bodyEditor[0], 'events');
    for (const keyEvent in events) {
      Object(this.cacheEvents)[keyEvent] = Object(events)[keyEvent];
      delete Object(events)[keyEvent];
    }

    let targetId = '';
    _this.$bodyEditor.off('mouseover.selecting-target').on('mouseover.selecting-target', function (e) {
      $mer.removeClass('gf-target-box');
      const $merParent = jQuery(e.target).is(_this.selectorClass)
        ? jQuery(e.target)
        : jQuery(e.target).parents(_this.selectorClass).first();
      $merParent.addClass('gf-target-box');
      targetId = $merParent.attr('id') || '';

      //add outline
      if (tempTimeout) {
        clearTimeout(tempTimeout);
      }
      tempTimeout = setTimeout(function () {
        _this.appendLabelOnTarget($merParent);
      }, 16);
    });
    _this.$bodyEditor.off('mouseup.select-target').on('mouseup.select-target', function (e) {
      e.preventDefault();
      e.stopPropagation();
      const $merParent = jQuery(e.target).is(_this.selectorClass)
        ? jQuery(e.target)
        : jQuery(e.target).parents(_this.selectorClass).first();
      if (targetId == $merParent.attr('id')) {
        if ($merParent.hasClass('gf-popupAnchor')) {
          //support Popup
          const popupTargetId = $merParent.attr('data-id');
          _this.updateTarget('m-' + popupTargetId, 'Popup', 'module');
        } else {
          const atomType = getAtomType($merParent);
          const atomLabel = $merParent.attr('data-label') || '';
          _this.updateTarget(targetId, atomLabel, atomType);
        }
        _this.disableSelectTargetMode();
      }
    });

    //click out to disableSelectTargetMode
    jQuery('#gfLeftSideBar, #divTopBar')
      .off('mouseup.closetarget')
      .on('mouseup.closetarget', function (e) {
        // if (_this.flagEnableSelectTarget) {
        //   _this.flagEnableSelectTarget = false;
        //   return;
        // }
        if (!$(e.target).is('.change-target') && !$(e.target).parents('.change-target').length) {
          e.preventDefault();
          _this.disableSelectTargetMode();
        }
      });

    return;
  }

  /**
   * appendLabelOnTarget
   * @param $target .
   */
  appendLabelOnTarget($target: JQuery): void {
    if (!$target.children('.gf-target-box-label').length) {
      let label = $target.attr('data-label');
      //for popup
      if ($target.hasClass('gf-popupAnchor')) {
        label = $target.children('span').text() || '';
      }
      // console.log($target);
      const html = `<div class="gf-target-box-label"><div class="gf-target-box-content">${svg(
        'selectTarget',
      )}Select ${label}</div></div>
      <div class="gf-target-outline gf-target-outline-top"></div>
      <div class="gf-target-outline gf-target-outline-bottom"></div>
      <div class="gf-target-outline gf-target-outline-left"></div>
      <div class="gf-target-outline gf-target-outline-right"></div>
      `;
      $target.append(html);
    }
  }

  /**
   * appendInfoBar
   */
  appendInfoBar(): void {
    if (!this.$bodyEditor.children('.gf-target-inforbar').length) {
      const html = `<div class="gf-target-inforbar">
      <div class="gf-target-inforbar-content">${svg(
        'selectTarget',
      )}<span>Select target element on iframe window</span></div>
      <span class="gf-target-inforbar-cancel">Cancel</span>
      </div>`;
      this.$bodyEditor.append(html);

      const _this = this;
      this.$bodyEditor
        .find('.gf-target-inforbar-cancel')
        .off('click')
        .on('click', function () {
          _this.disableSelectTargetMode();
        });
    }
  }

  /**
   * pushAction
   * @param action .
   */
  pushAction(action: ActionDataEditor): void {
    //check if not found action
    if (!action.name && !action.settings.length) {
      //action not found
      return;
    }

    const key = Object.keys(this.actionItems).length;
    Object(this.actionItems)[key] = new ActionItem(this.$targetActions, action);
    Object(this.actionItems)[key].setCallback((typeCallback: string) => this.actionCallback(typeCallback, key));
  }

  /**
   * duplicateAction
   * @param type .
   * @param key .
   * @returns any (void | $atom)
   */
  actionCallback(type: string, key: number): any {
    if (type == 'duplicate') {
      const tempActionItems = {};
      let newIndex = 0;

      for (const i in this.actionItems) {
        const index = parseInt(i);

        const tempIndex = newIndex;
        Object(tempActionItems)[tempIndex] = Object(this.actionItems)[index];
        Object(tempActionItems)[tempIndex].setCallback((typeCallback: string) =>
          this.actionCallback(typeCallback, tempIndex),
        );

        if (key == index) {
          newIndex++;
          const dupIndex = newIndex;
          const action = mergeActionToEditor(Object(this.actionItems)[key].export(), this.atomLabel);
          Object(tempActionItems)[dupIndex] = new ActionItem(
            this.$targetActions,
            action,
            Object(this.actionItems)[key].$html,
          );
          Object(tempActionItems)[dupIndex].setCallback((typeCallback: string) =>
            this.actionCallback(typeCallback, dupIndex),
          );
          Object(tempActionItems)[dupIndex].$html.find('.action-head').trigger('click');
        }
        newIndex++;
      }

      this.actionItems = tempActionItems;
      store.setValue('update-action', 1);
      return;
    }

    if (type == 'move-up') {
      //ignore if before not found

      const tempActionItems = {};
      let newIndex = 0;
      let swap = false;
      for (const i in this.actionItems) {
        const index = parseInt(i);
        const tempIndex = newIndex;
        Object(tempActionItems)[tempIndex] = Object(this.actionItems)[index];
        Object(tempActionItems)[tempIndex].setCallback((typeCallback: string) =>
          this.actionCallback(typeCallback, tempIndex),
        );

        if (key == index && tempIndex > 0) {
          swap = true;
        }

        if (swap) {
          swap = false;
          //temp before
          const tempBefore = Object(tempActionItems)[tempIndex - 1];
          const $tempHtml = Object(tempActionItems)[tempIndex - 1].$html.detach();

          //move current to before
          Object(tempActionItems)[tempIndex - 1] = Object(tempActionItems)[tempIndex];
          Object(tempActionItems)[tempIndex - 1].setCallback((typeCallback: string) =>
            this.actionCallback(typeCallback, tempIndex - 1),
          );

          Object(tempActionItems)[tempIndex] = tempBefore;
          Object(tempActionItems)[tempIndex].setCallback((typeCallback: string) =>
            this.actionCallback(typeCallback, tempIndex),
          );

          Object(tempActionItems)[tempIndex - 1].$html.after($tempHtml);
        }
        newIndex++;
      }
      this.actionItems = tempActionItems;
      store.setValue('update-action', 1);
      return;
    }

    if (type == 'move-down') {
      this.actionCallback('move-up', key + 1);
      return;
    }

    if (type == 'get-atom') {
      return this.$bodyEditor.find(this.id);
    }
  }

  /**
   * updateTarget
   * @param targetId ..
   * @param targetLabel ..
   * @param targetType ..
   */
  updateTarget(targetId: string, targetLabel: string, targetType: string): void {
    //add type of target row,module,element
    this.id = '#' + targetId;
    this.atomLabel = targetLabel;
    this.atomType = targetType;
    this.rename = `${this.atomLabel}: ${this.id}`;
    this.$targetLabelText.val(this.rename);
    this.$targetLabel.attr('data-target', this.id);
    this.$targetLabel.attr('data-type', this.atomType);
    this.refreshListActions();
    this.checkActionsSupport();
    store.setValue('update-action', 1);
    return;
  }

  /**
   * check Actions support
   */
  checkActionsSupport(): void {
    const actions = listActions(this.atomLabel);
    const supportKey = actions.map((action) => {
      return action.key;
    });
    for (const i in this.actionItems) {
      const actionKey = Object(this.actionItems)[i].key;
      if (supportKey.indexOf(actionKey) == -1) {
        //no support
        Object(this.actionItems)[i].setSupport(false);
      } else {
        Object(this.actionItems)[i].setSupport(true);
      }
    }
  }

  /**
   * setDuplicateCallback
   * @param callback .
   * @returns ..
   */
  setDuplicateCallback(callback: any): void {
    this.duplicateCallback = callback;
  }

  /**
   * duplicate: Gọi lên callback rồi để FlowActionItem duplicate
   * @returns ..
   */
  duplicate(): void {
    this.duplicateCallback();
  }

  /**
   * remove
   * @returns ..
   */
  remove(): void {
    this.$html.remove();
    this.flagRemoved = true;
    store.setValue('update-action', 1);
  }

  /**
   * enable queue mode
   * @returns ..
   */
  /*  toggleQueue(): void {
    this.flagIsQueue = !this.flagIsQueue;


  } */

  /**
   * export
   * @returns ..
   */
  export(): TargetData | undefined {
    if (this.flagRemoved) {
      return undefined;
    }
    const actions: ActionData[] = [];
    for (const key in this.actionItems) {
      const action = Object(this.actionItems)[key].export();
      if (action) {
        actions.push(action);
      }
    }

    const exportData: TargetData = {
      id: this.id,
      actions: actions,
    };

    if (this.actionType) {
      exportData['actionType'] = this.actionType;
    }
    if (this.rename) {
      exportData['rename'] = this.rename;
    }

    return exportData;
  }
}
